/**
 * Route-Helfer für die Nutzungsspur (pure, getestet).
 * Query und Hash werden nie erfasst — sie können IDs/Suchbegriffe enthalten.
 */

/** Routen ohne Login — dort wird nichts erfasst. Präfix gilt als Segment-Grenze. */
export const OEFFENTLICHE_ROUTEN = ['/login', '/forgot-password', '/reset-password', '/invite', '/oeffentlich'] as const;

export function normalisiereRoute(route: string): string {
  const idx = route.search(/[?#]/);
  const pfad = idx === -1 ? route : route.slice(0, idx);
  return pfad === '' ? '/' : pfad;
}

export function extrahiereProgrammeId(pathname: string): string | null {
  const teile = normalisiereRoute(pathname).split('/').filter(Boolean);
  if (teile[0] === 'programme' && teile[1]) return teile[1];
  return null;
}

export function istOeffentlicheRoute(pathname: string): boolean {
  const pfad = normalisiereRoute(pathname);
  return OEFFENTLICHE_ROUTEN.some((p) => pfad === p || pfad.startsWith(`${p}/`));
}
